
import Modal from 'react-modal';
import MgpFormCheckbox from '../../elements/MgpFormCheckbox/MgpFormCheckbox';
import { UseFormRegister, UseFormSetError, UseFormWatch } from 'react-hook-form';
import { accessJsonAttr, handleKeyDown } from '../../utils/utils';
import { ERROR_MESSAGES } from '../../const/AppConst';

type MGProtectModalProps = {
    isOpen?: boolean;
    onConfirmAction: () => void;
    onCloseModal: () => void;    
    text?: string;
    refuseButtonName?: string;
    acceptButtonName?: string;
    register: UseFormRegister<any>;
    errors?: any;
    watch: UseFormWatch<any>;
    setError: UseFormSetError<any>
    };

export default function MGProtectModal({isOpen = false, onConfirmAction, onCloseModal, register, text, refuseButtonName, acceptButtonName, errors, watch, setError}: MGProtectModalProps) {
    Modal.setAppElement("#root");

    const isChecked = watch('protectedConditions')

    const handleConfirmAction = () => {
        if (isChecked) {
            onConfirmAction();
        } else {
            setError('protectedConditions', {message: "Veuillez cocher la case"})
        }
    }
    return(
        <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
            <div className="modale open">
                <div className="modale--content">
                    <div className="modale--content--template">
                        <div className="modale--main-width-entreprise p-lg shadow-bleu m-y-xl bg-blanc ">
                            <div className='va-center'>
                                <div className="m-y-md text"> 
                                    <p className='mb-lg'>En m'inscrivant à MGPROTECT Localisation, je m'engage à&nbsp;:</p>
                                    <p>- donner obligatoirement mon numéro de téléphone portable et mon adresse électronique&nbsp;;</p>
                                    <p>- utiliser exclusivement ces deux moyens de communication pour échanger avec la MGP&nbsp;;</p>
                                    <p>- informer immédiatement la MGP en cas de changement de mes coordonnées téléphoniques ou électroniques&nbsp;;</p>
                                    <p>- accepter de ne pas envoyer à la MGP des documents par voie postale ni de recevoir de la MGP des documents par voie postale&nbsp;;</p>
                                    <p>- accepter de recevoir les informations de la MGP dans ma boîte aux lettres électroniques&nbsp;;</p>
                                    <p>- <strong>masquer ou découper la mention de mon adresse postale sur tous les documents que je transmets à la MGP&nbsp;;</strong></p>
                                    <p>- accéder à ma carte de tiers payant à partir du site www.mgp.fr&nbsp;;</p>
                                    <p>- consulter mes remboursements en ligne sur www.mgp.fr&nbsp;;</p>
                                    <p>- accéder à l'information notifiée par la MGP par la mise à disposition dans mon espace adhérent sur www.mgp.fr&nbsp;: magazine, documents contractuels, etc.</p>
                                    <p>- vérifier par la suite si mon compte ameli, accessible depuis mon espace adhérent sur mgp.fr, est actif afin de ne plus recevoir de courrier papier à mon domicile.</p>
                                    <p className='mt-lg'>J'ai bien compris que le strict respect de ces engagements est nécessaire afin de permettre à la MGP de respecter ses propres engagements. En cas de transmission de mon adresse postale, la MGP pourra la traiter. Par ailleurs, en cas de non-respect de mes obligations contractuelles liées à mon adhésion, la MGP pourra mettre fin, totalement ou partiellement, de plein droit et sans aucune formalité, au dispositif MGPROTECT Localisation. Ainsi, la MGP pourra collecter et traiter mon adresse postale.</p>   
                                </div>

                                <div className='mb-xs'>
                                    <div className="">
                                        <div className="form-group mw-100 form-check-modal">
                                            <MgpFormCheckbox 
                                                id='protectedConditions' 
                                                label="J’ai lu les conditions d’utilisation du service et je m’engage à les respecter."
                                                register={register} 
                                                errors={errors}
                                                required
                                            />
                                        </div>
                                        <div className="mt-xs">
                                            {errors && accessJsonAttr(errors, 'protectedConditions') && <p className="fushia">Veuillez cocher la case</p>}
                                        </div>   
                                    </div> 
                                </div>
                            </div>        
                                <div className="ta-center">
                                    <a className="cta-inline-bleu m-x-md" onClick={onCloseModal} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>{refuseButtonName ? refuseButtonName : 'Annuler'}</a>
                                    <a className="cta-bleu cta-small ml-x-md" onClick={handleConfirmAction} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>{acceptButtonName ? acceptButtonName : 'Confirmer'}</a>   
                                </div>
                            </div>
                       
                    </div>
                </div>
            </div>
        </Modal>
    )
}